"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _Discussion = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _userProfile = require("user-profile");

var _class;

var Event = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Event, _Activity);

  function Event() {
    babelHelpers.classCallCheck(this, Event);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Event).apply(this, arguments));
  }

  babelHelpers.createClass(Event, [{
    key: "setup",
    value: function setup(event) {
      var _this = this;

      this.eventObject = event;
      this.addEventListener('startedActivity', this._eventStarted);
      this.addEventListener('timerExpired', function () {
        return _this.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      this.startActivity();
      if (this.readOnly) this.activityComplete();
    }
  }, {
    key: "_eventStarted",
    value: function _eventStarted(event) {
      var _this2 = this;

      // this.showActivityTitle();
      if (!this.readOnly) {
        if (!this.eventObject.unconfirmedDate) {
          // Use 5 minutes here.
          var E = this.eventObject.end == this.eventObject.start ? this.eventObject.start + 300000 : this.eventObject.end;
          if (E < Date.now()) this.endActivity();else this.startTimer(E - Date.now(), true);
        } else {
          (0, _fetch.default)("data/discussion/item?node=".concat(this.eventObject.discussionRoot)).then(function (r) {
            return r.json();
          }).then(function (data) {
            if (data.node.child_type == 'eventScheduleRoot') {
              var rn = _this2.$('.schedule-container');

              rn.append("<div class='assignment-wrapper event-schedule-wrapper'><div class='assignment-header'>Scheduling</div><div id=\"discussionRoot\"></div></div>");
              var root = rn[0].querySelector('div#discussionRoot');
              (0, _userProfile.getUserProfile)().then(function (profile) {
                _reactDom.default.render(_react.default.createElement(_Discussion.default, {
                  discussionRoot: _this2.eventObject.discussionRoot,
                  userId: profile.id,
                  commentPosted: _this2._commentPosted,
                  trackData: {}
                }), root);
              });
            }
          });
        }
      }
    }
  }, {
    key: "_commentPosted",
    value: function _commentPosted() {
      var _this3 = this;

      (0, _fetch.default)("data/discussion/feed?node=".concat(this.eventObject.discussionRoot)).then(function (r) {
        return r.json();
      }).then(function (data) {
        // If the feed contains an 'accept' node, then we should refresh the activity.
        for (var i in data.items) {
          if (data.items[i].child_type == 'accept') {
            _this3.reloadActivityBody();

            return;
          }
        }
      });
    }
  }]);
  return Event;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_eventStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_eventStarted"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_commentPosted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_commentPosted"), _class.prototype)), _class);
exports.default = Event;